module.exports = __webpack_public_path__ + "static/media/marius-ciocirlan-398931-unsplash.c3a4e850.jpg";